import { ActionReducerMap } from "@ngrx/store";
import { ReportDataState, reportsDataReducer } from "./data.reducer";
import { SlidesSate, slidesReducer } from './slides.reducer';
import { exportReducer, ExportState } from "./export.reducer";
import { CacheState, reducer } from "./cache.reducer";

export interface ReportsState {
    data: ReportDataState;
    slides: SlidesSate;
    export: ExportState;
    cache: CacheState
}

export const reducers: ActionReducerMap<ReportsState> = {
    data: reportsDataReducer,
    slides: slidesReducer,
    export: exportReducer,
    cache: reducer
};

export * from './data.reducer';